<template>
    <section id="dashboard" v-loading="loading">
        <el-container style="max-width:600px">
            <el-input placeholder="Search text" v-model="search"></el-input>
            <el-button icon="el-icon-search" type="primary" @click="loadData">Search</el-button>
        </el-container>
        <el-table
            :default-sort="{prop: 'id', order: 'descending'}"
            :data="tableData"
            stripe
            @sort-change="handleSortChange"
            style="width: 100%">
            <el-table-column prop="id" label="ID" width="70" sortable>
            </el-table-column>
            <el-table-column prop="name" label="Name" sortable></el-table-column>
            <el-table-column prop="email" label="E-mail" sortable></el-table-column>
            <el-table-column prop="phone" label="Phone" sortable></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            layout="sizes, prev, pager, next, total"
            :total="total">
        </el-pagination>
    </section>
</template>

<script>
import adminApi from '../api'

export default {
    name: 'FrontendUsers',
    data() {
        return {
            loading: false,
            search: null,
            formType: null,
            currentPage: 1,
            pageSize: 10,
            sort: {prop: 'id', order: 'descending'},
            total: 0,
            tableData: [],
            rowToShow: null,
            fullScreenLoading: false
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        handleSortChange({column, prop, order}) {
            if (!order) {
                this.sort = {prop: 'id', order: 'desc'};
            } else {
                this.sort = {prop: prop, order: order};
            }
            this.loadData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            adminApi.getFrontendUserList({
                search: this.search,
                formType: this.formType,
                page: this.currentPage,
                perPage: this.pageSize,
                orderBy: this.sort.prop,
                orderWay: (this.sort.order == 'ascending' ? 'asc' : 'desc')
            }).then((r) => {
                this.tableData = r.data.data;
                this.total = r.data.total;
            }).catch((err) => {

            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-select--mini .el-input__inner {
    padding-right: 0 !important;
}
</style>
